import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import axios from "axios";
import { ROL_SUPERADMIN, ROL_PERFIL_ADMINISTRADOR } from '../constants/roles';
import './Login.scss';

export const Login = (props) => {
    const toast = useRef(null);
    const anioActual = new Date().getFullYear();
    const navigate = useNavigate();
    const [form, setForm] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const HOST_API = process.env.REACT_APP_URL;

    const showError = (detail) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail, life: 4000 });
    };

    const handleChangeLogin = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleLogin = async () => {
        if (submitting) return;

        const body = {
            userName: form.user,
            password: form.password
        };

        if (!body.userName) { showError('Completá el usuario'); return; }
        if (!body.password) { showError('Completá la contraseña'); return; }

        setSubmitting(true);
        try {
            const url = `${HOST_API}api/usersAdm/authenticate`;
            const response = await axios.post(url, body, {
                headers: { 'Content-Type': 'application/json' }
            });

            const userData = response.data;

            localStorage.setItem("user",               JSON.stringify(userData));
            localStorage.setItem("rolId",               userData.rolId ?? 1);
            localStorage.setItem("administracionId",    userData.administracionId ?? 1);
            localStorage.setItem("administracionLogo",  userData.administracionLogo || 'expensas360.png');
            localStorage.setItem("tipoAdministracion",  userData.tipoAdministracion || 'Barrio Cerrado');
            localStorage.setItem("barriosPermitidos",   JSON.stringify(userData.barriosPermitidos ?? []));

            const rolId   = userData.rolId ?? 1;
            const barrios = userData.barriosPermitidos ?? [];

            if (rolId === ROL_SUPERADMIN) {
                navigate("/liquidacionMensual");
            } else if (rolId === 1 || rolId === ROL_PERFIL_ADMINISTRADOR) {
                navigate("/dashboardGeneral");
            } else if (barrios.length === 0) {
                navigate("/tableBarrios");
            } else if (rolId === 3) {
                navigate("/dashboardPortero");
            } else {
                navigate("/portal");
            }
        } catch (err) {
            console.error('Error en login:', err);
            showError(err.response?.data?.message || 'Error al iniciar sesión');
        } finally {
            setSubmitting(false);
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        handleLogin();
    };

    const handleKeyUpEnter = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="ef-login">

                <div className="ef-login-visual">
                    <img className="ef-login-bg" src="assets/layout/images/pages/login.jpg" alt="" />
                    <div className="ef-login-overlay"></div>

                    <div className="ef-login-brand">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M3 12L12 4L21 12" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 11V20H18V11" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span>EXPENSAS<b>360</b></span>
                    </div>

                    <div className="ef-login-headline">
                        <h1>Todo tu barrio,<br />en un solo panel.</h1>
                        <p>Gestioná expensas, pagos y comunicación con tus vecinos de forma simple, desde cualquier lugar.</p>
                    </div>

                    <div className="ef-login-stats">
                        <div>
                            <div className="value">+120</div>
                            <div className="label">Barrios y consorcios</div>
                        </div>
                        <div className="divider"></div>
                        <div>
                            <div className="value">24/7</div>
                            <div className="label">Acceso a tu cuenta</div>
                        </div>
                    </div>
                </div>

                <div className="ef-login-panel">
                    <div className="ef-login-panel-inner">

                        <img className="ef-login-logo" src="./assets/layout/images/ab/expensas360.png" alt="Expensas360" />

                        <h2 className="ef-login-title">Bienvenido de nuevo</h2>
                        <p className="ef-login-subtitle">Ingresá tus datos para acceder a tu cuenta</p>

                        <div className="ef-login-field">
                            <label htmlFor="user">Usuario</label>
                            <div className="ef-login-input-wrap">
                                <svg className="icon-left" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M4 6H20V18H4V6Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                                    <path d="M4 7L12 13L20 7" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                                </svg>
                                <InputText
                                    id="user"
                                    name="user"
                                    type="text"
                                    placeholder="tu.usuario@email.com"
                                    className="ef-login-input"
                                    value={form.user || ''}
                                    onChange={handleChangeLogin}
                                    onKeyUp={handleKeyUpEnter}
                                />
                            </div>
                        </div>

                        <div className="ef-login-field">
                            <label htmlFor="password">Contraseña</label>
                            <div className="ef-login-input-wrap">
                                <svg className="icon-left" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.6" />
                                    <path d="M8 11V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                </svg>
                                <InputText
                                    id="password"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="••••••••"
                                    className="ef-login-input has-toggle"
                                    value={form.password || ''}
                                    onChange={handleChangeLogin}
                                    onKeyUp={handleKeyUpEnter}
                                />
                                <button
                                    type="button"
                                    className="ef-login-eye-toggle"
                                    onClick={() => setShowPassword(v => !v)}
                                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                >
                                    {showPassword ? (
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <path d="M3 3L21 21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                            <path d="M10.6 5.63C11.06 5.55 11.53 5.5 12 5.5C18.5 5.5 22 12 22 12C21.6 12.7 20.85 13.77 19.75 14.8M6.6 6.6C4.05 8.15 2 12 2 12C2 12 5.5 18.5 12 18.5C13.9 18.5 15.5 17.95 16.8 17.15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M9.9 10.1C9.5 10.5 9.25 11.02 9.25 11.6C9.25 12.7 10.15 13.6 11.25 13.6C11.83 13.6 12.35 13.35 12.7 12.95" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    ) : (
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <path d="M2 12C2 12 5.5 5.5 12 5.5C18.5 5.5 22 12 22 12C22 12 18.5 18.5 12 18.5C5.5 18.5 2 12 2 12Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                                            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="ef-login-forgot-row">
                            <button type="button" className="ef-login-link" onClick={() => navigate('/forgotPassword')}>¿Olvidaste tu contraseña?</button>
                        </div>

                        <Button
                            type="button"
                            label="Iniciar sesión"
                            className="ef-login-submit"
                            loading={submitting}
                            onClick={handleClick}
                        />

                        <p className="ef-login-signup">
                            ¿No tenés cuenta? <button type="button" className="ef-login-link">Registrate</button>
                        </p>

                        <p className="ef-login-footer">© {anioActual} Expensas360 — Administración de Barrios y Consorcios</p>

                    </div>
                </div>

            </div>
        </>
    );
};
